module.exports = __webpack_public_path__ + "static/new-hero-mobile-42ff7da45c9824c2ba2e4ba47d335d8e.webp";